import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class AdminService {
    constructor(private http: AuthHttp) { }

    get(type: string) {
        return this.http.get('/api/' + type);
    }

    add(type: string, data: any): Observable<Response> {
        return this.http.post('/api/' + type, data)
            .map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json()));
    }

    update(type: string, data: any): Observable<Response> {
        return this.http.put('/api/' + type, data)
            .map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json()));
    }

    delete(type: string, data: any): Observable<Response> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, body: data });

        return this.http.delete('/api/' + type, options)
            .map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json()));
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_services/admin.service.ts